<template>
  <div class="material-container">
    <template v-if="imgUrl">
      <div class="material-img">
        <img v-lazy-load v-lazy-load :data-src="imgUrl">
      </div>
    </template>
    <template v-else-if="videoUrl">
      <video id="material-video" />
    </template>
    <div v-if="videoUrl" class="button-video-play" @click="handleVideo" />
  </div>
</template>
<script>
export default {
  props: {
    videoUrl: {
      default: '',
      type: String,
    },
    imgUrl: {
      default: '',
      type: String,
    },
  },
  mounted() {
    if (this.videoUrl && !this.imgUrl) {
      const video = document.getElementById('material-video')
      video.src = this.videoUrl
      video.load()
    }
  },
  methods: {
    handleVideo() {
      this.$emit('open-video', this.videoUrl)
    },
  },
}
</script>
<style lang="scss" scoped>
.material-container {
  position: relative;

  #material-video,
  .material-img {
    width: 560px;
    height: 420px;
    background: #f4f6fa;
    border-radius: 12px;
    overflow: hidden;
  }

  .material-img {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      display: flex;
      width: 560px;
      height: 420px;
    }
  }

  .button-video-play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 70px;
    height: 70px;
    background: url('~assets/images/our-courses/video-play.png');
    background-size: 100%;
    cursor: pointer;
    z-index: 10;
  }
}
</style>
